/**
 * Short-lived in-memory memo for the email a user just submitted to
 * /magic-link. Read by /magic-link-sent to personalize the confirmation
 * copy and to resend if the user taps "Send again".
 *
 * Why not a URL param? An email address in the URL leaks to browser
 * history, server access logs, HTTP Referer headers, screen shares, and
 * anything that auto-captures pageview URLs (PostHog, Datadog RUM, browser
 * extensions). We already treat identifiers as sensitive elsewhere; the
 * confirmation screen isn't worth breaking that rule for.
 *
 * Persistence characteristics:
 *   - Client-side JS module scope: lost on hard refresh, tab close, or
 *     navigation that bootstraps a new bundle. That's fine — the fallback
 *     is a generic "your email" copy, which stays accurate.
 *   - Not written to storage: no long-lived residue on the device.
 */
let pendingEmail: string | null = null;

export const setPendingMagicLinkEmail = (email: string): void => {
  pendingEmail = email;
};

export const getPendingMagicLinkEmail = (): string | null => pendingEmail;

export const clearPendingMagicLinkEmail = (): void => {
  pendingEmail = null;
};
